export const supportsSession = ((context, mod) => {
    try {
        context.setItem(mod, mod);
        context.removeItem(mod);
        return true;
    }
    catch (e) {
        return false;
    }
})(window.sessionStorage, 'sessiontest');
export const supportsCookie = ((mod) => {
    try {
        document.cookie = `${mod}1`;
        const ret = document.cookie.indexOf(mod) > -1;
        document.cookie = `${mod}1; expires=Thu, 01-Jan-1970 00:00:01 GMT`;
        return ret;
    }
    catch (e) {
        return false;
    }
})('cookietest=');
export const Navigation = {
    navigate: 'navigate',
    reload: 'reload',
    back_forward: 'back_forward',
    prerender: 'prerender',
};
export const htmlElement = document.documentElement;
const navigationTypes = [Navigation.navigate, Navigation.reload, Navigation.back_forward];
export const browser = {
    get width() {
        return htmlElement.clientWidth;
    },
    get height() {
        return htmlElement.clientHeight;
    },
    get navigationType() {
        try {
            return performance.getEntriesByType('navigation')[0].type;
        }
        catch (e) {
            return getNavigationTypeLegacy();
        }
    },
};
try {
    browser.hover = matchMedia('(hover: hover), (-ms-high-contrast: active), (-ms-high-contrast: none)').matches;
}
catch (e) {
    browser.hover = true;
}
function getNavigationTypeLegacy() {
    try {
        return navigationTypes[performance.navigation.type];
    }
    catch (e) {
        return Navigation.navigate;
    }
}
//# sourceMappingURL=browser-support.js.map